import { Component, TemplateRef, ViewChild, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatDialog, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { BehaviorSubject, Observable, Subject, takeUntil } from 'rxjs';
import { ApiResponse, CamDeleteModel } from 'src/app/models/interface/CAM/baseResponseInterfaces';
import { Branch, BranchByIdData, BranchRequest, Division } from 'src/app/models/interface/CAM/CompanyProfileInterface';
import { RegistationUtilitiesService } from 'src/app/modules/registration/services/registation-utilities.service';
import { ApiService } from 'src/app/services/apiService/api.service';
import { CamService } from 'src/app/services/camService/cam.service';
import { CompanyManagementService } from 'src/app/services/dataLayer/CAM/company-management.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { CompanyManagementContentService } from '../../services/company-management-content.service';
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';
import { environment } from 'src/environments/environment';
import { WaitingComponent } from '../../../../shared/components/waiting/waiting.component';
import { NgIf, NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatAccordion, MatExpansionPanel, MatExpansionPanelTitle } from '@angular/material/expansion';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatFormField, MatLabel, MatError, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { NgSelectComponent, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgLabelTemplateDirective, NgNotFoundTemplateDirective } from '@ng-select/ng-select';
import { MatSelect } from '@angular/material/select';
import { MatButton } from '@angular/material/button';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { CamEmptyStateComponent } from '../cam-empty-state/cam-empty-state.component';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { ContentService } from '../../services/content.service';


export interface StateGroup {
  letter: string;
  names: {
    name: string;
    code: string;
    isdCode: string;
    countryFlag: string;
  }[];
}

export interface City {
  cityName: string;
  cityCode: string;
}

@Component({
    selector: 'app-branch-info',
    templateUrl: './branch-info.component.html',
    styleUrls: ['./branch-info.component.scss'],
    imports: [WaitingComponent, NgIf, ReactiveFormsModule, MatIcon, MatAccordion, MatExpansionPanel, MatExpansionPanelTitle, MatRadioGroup, MatRadioButton, MatFormField, MatLabel, MatInput, MatError, MatSuffix, NgSelectComponent, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgLabelTemplateDirective, NgNotFoundTemplateDirective, MatSelect, MatButton, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, NgClass, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, CamEmptyStateComponent, CdkScrollable, MatDialogContent, MatDialogActions]
})
export class BranchInfoComponent implements OnInit, OnDestroy {
  public _siteCoreBaseUrl = environment.siteCoreBaseUrl;
  displayedColumns: string[] = ['Branch', 'City', 'Email Address', 'Phone Number', 'Status', 'Actions'];
  // dataSource = ELEMENT_DATA;
  Addnew: boolean = false
  tableData: Branch[] = []
  branchForm: FormGroup | any
  countriesLists: any[] = [];
  filteredCountries: any;
  isLoading = true; // Start loading state

  filteredCities: { cityName: string; cityCode: string }[] = [];
  selectedCity: City | null = null;
  cityControl = new FormControl('');
  PreviousCity: string = '';
  PreviousCityCode: string = 'SA';
  noResultsFound = false;
  isCityDirty = false;
  Isdivision = false;
  divisionList: Division[] = []
  stateGroupOptions: Observable<StateGroup[]> = new Observable<StateGroup[]>();
  private stateGroupSubject: BehaviorSubject<StateGroup[]> = new BehaviorSubject<StateGroup[]>([]);
  allCities: any;
  manageTravelerContent:any;
  @ViewChild('selectionWarning') selectionWarning!: TemplateRef<any>;
  currentItem: any;

  @ViewChild('countryRegion') countryRegionAutocomplete: any;
  @ViewChild('countryRegionTrigger', { read: MatAutocompleteTrigger }) countryRegionTrigger!: MatAutocompleteTrigger;
  @ViewChild('cityTrigger', { read: MatAutocompleteTrigger }) cityTrigger!: MatAutocompleteTrigger;

  commonObjPipes: any = {
    countyname: { pipe: [], all: [] },
    countryCode: { pipe: [], all: [] },
    city: { pipe: [], all: [] },
  }
  content:any;
  dictionaryContent:any;
  private destroy$ = new Subject<void>();
  constructor(private _camService: CamService, private fb: FormBuilder, public _ApiService: ApiService, private registrationUtility: RegistationUtilitiesService, private _ToastrApiService: ToastrApiService, private dialog: MatDialog, public _CommonService: CommonService, private _CompanyManagementService: CompanyManagementService,private contentService:CompanyManagementContentService, private readonly dictionaryContentService:DisctionaryContent,private readonly manageTravelercontentService: ContentService) {
    this.stateGroupOptions = this.stateGroupSubject.asObservable();
    this.branchForm = this.fb.group({
      flag: ['ADD'],
      branchId: [null],
      branchDetails: this.fb.group({
        status: [true, [Validators.required]],
        // division: [0, [Validators.required]],
        corporateBranchName: ['', [Validators.required, Validators.minLength(2), Validators.maxLength(100)]],
        branchCode: ['', [Validators.required, Validators.minLength(3), Validators.maxLength(20), Validators.pattern('^[a-zA-Z0-9]+$')]],
        alternateBranchCode: ['', [Validators.minLength(3), Validators.maxLength(20), Validators.pattern('^[a-zA-Z0-9]+$')]],
        branchEmailAddress: ['', [Validators.required,Validators.email, Validators.maxLength(100)]],
        streetAddress: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(200)]],
        countryRegion: ['', [Validators.required, Validators.maxLength(50)]],
        state: [''],
        city: ['', [Validators.required, Validators.maxLength(50)]],
        postalCode: ['', [Validators.minLength(6), Validators.maxLength(12)]],
        mobileNumber: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(12)]],
        telephone: ['', [Validators.maxLength(15), Validators.minLength(8)]],
        fax: ['', [Validators.minLength(7), Validators.maxLength(15)]]
      }),
      // branchPOC: this.fb.group({
      //   contactName: ['', [Validators.pattern('^[a-zA-Z\\s]{2,}$'), Validators.maxLength(100), Validators.minLength(2)]],
      //   contactEmailAddress: ['', [Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)]],
      //   contactMobile: ['', [Validators.maxLength(15), Validators.minLength(7)]],
      //   gdsOfficeID: ['', [Validators.maxLength(10), Validators.minLength(3)]],
      //   securityManagerID: ['', [Validators.maxLength(15), Validators.minLength(3)]]
      // }),
      // references: this.fb.group({
      //   additionalReferenceOne: ['', [Validators.minLength(2), Validators.maxLength(100)]],
      //   additionalReferenceTwo: ['', [Validators.minLength(2), Validators.maxLength(100)]],
      //   additionalReferenceThree: ['', [Validators.minLength(2), Validators.maxLength(100)]],
      //   additionalReferenceFour: ['', [Validators.minLength(2), Validators.maxLength(100)]],
      //   additionalReferenceFive: ['', [Validators.minLength(2), Validators.maxLength(100)]]
      // })
    });
  }


  ngOnInit(): void {
    this.contentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.content = res;
    });
    this.dictionaryContentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.dictionaryContent = res;
    });

    this.manageTravelercontentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
      this.manageTravelerContent = res;
    });

    this._ApiService.getCountriesData().then(($res) => {
      // this.groupCountries($res);
      this.countriesLists = this._CommonService.groupCountriesFilter($res);

    }).catch(($err) => {
      console.error($err)
    });
    // this.getDivisionList()
    this.getBranchInfoList()

    this.branchForm.get('branchDetails.countryRegion').valueChanges.subscribe((countryCode: any) => {
      if (!countryCode) {
        this.clearCityList('city');
      }
    });

  }

  getImageUrl(path: string): string {
    if (!path) return '';
  
    const base = this._siteCoreBaseUrl?.replace(/\/+$/, '') || '';
    const cleanPath = path.replace(/^\/+/, '');
  
    return `${base}/${cleanPath}`;
  }

  filterCountries(event: any, cityKey: string) {
    // Clear city list if no country is selected
    if (!event) {
      this.clearCityList(cityKey);
      return;
    }

    // If country is selected, get cities for that country
    this.branchForm.get('branchDetails.countryRegion')?.setValue(event.isoCode);
    this.getCitiesForCountry(event.isoCode, cityKey);
  }

  clearCityList(cityKey: string) {
    this.commonObjPipes[cityKey].all = [];
    this.commonObjPipes[cityKey].pipe = [];
    this.branchForm.get('branchDetails').get(cityKey)?.setValue(null);
  }

  getCitiesForCountry(countryCode: string, cityKey: string) {
    this.clearCityList(cityKey); // Clear first

    this.registrationUtility.getCities(countryCode, '').subscribe(
      (cities) => {
        this.commonObjPipes[cityKey].all = cities;
        this.commonObjPipes[cityKey].pipe = cities;
        this.noResultsFound = cities.length === 0;
      },
      (error) => {
        console.error('Error fetching city data', error);
        this.noResultsFound = true;
      }
    );
  }

  filteredCitiesFunc(countryCode: any, cityKey: string) {
    this.commonObjPipes[cityKey].all = [];
    this.commonObjPipes[cityKey].pipe = [];
    this.branchForm.get('branchDetails').get(cityKey)?.setValue(null);
    this.registrationUtility.getCities(countryCode?.code ?? countryCode, '').subscribe((cities) => {
      this.commonObjPipes[cityKey].all = cities;
      this.commonObjPipes[cityKey].pipe = cities;
      this.noResultsFound = cities.length === 0;
    }, (error) => { console.error('Error fetching city data', error); this.noResultsFound = true; });

  }

  loadCities(countryCode: string) {
    this.commonObjPipes.city.all = [];
    this.commonObjPipes.city.pipe = [];
    this.registrationUtility.getCities(countryCode, '').subscribe(
      (cities) => {
        this.commonObjPipes.city.all = cities;
        this.commonObjPipes.city.pipe = cities;
      },
      (error) => {
        console.error('Error loading cities:', error);
      }
    );
  }

  onEnterpress(event: Event) {
    if (event instanceof KeyboardEvent) {
      event.preventDefault();
      event.stopPropagation();

      if (this.filteredCountries.length > 0) {
        const firstCountry = this.filteredCountries[0];
        this.branchForm.get('branchDetails.countryRegion')?.setValue(firstCountry.isoCode);
        this.onCountrySelected();

        // Close the autocomplete panel using MatAutocompleteTrigger
        if (this.countryRegionTrigger) {
          this.countryRegionTrigger.closePanel();
        }
      }
    }
  }

  onCityEnter(event: Event) {
    if (event instanceof KeyboardEvent) {
      event.preventDefault();
      event.stopPropagation();
      if (this.filteredCities.length > 0) {
        const firstCity = this.filteredCities[0];
        this.branchForm.get('branchDetails.city')?.setValue(firstCity.cityName);
        this.onCitySelected(firstCity);
        if (this.cityTrigger) {
          this.cityTrigger.closePanel();
        }
      }
    }
  }



  getCountryName(
    selectedCountry: { name: string; code: string } | null
  ): string {
    return selectedCountry ? selectedCountry.name : '-';
  }


  handleEvent(event: string) {
    if (event.includes('branch-information')) {
      this.Addnew = true;
    }
  }

  addNewBranch() {
    this.Addnew = true;
    this.branchForm.reset({
      branchDetails: { status: true },
      flag: 'ADD',
      branchId: null,
    })

    this._CompanyManagementService.office_location_click('Add link','Add', this.tableData.length)//GTM use

  }



  getBranchInfoList() {

    this.isLoading = true; // Start loading state
    this._camService.GetBranchInformation()
      .then((res: ApiResponse<Branch[]>) => {
        if (res?.status == 'Success') {
          this.tableData = res.data

        } else {
          this.tableData = [];
        }
      })
      .catch((err: any) => {
        const errMsg = 'Something went wrong while fetching Branch Information List.';
        this._CompanyManagementService.view_error_message(errMsg,err?.code);
        this._ToastrApiService.show('error', errMsg)
        console.error("Error fetching branch information:", err);
        this.tableData = []; // Reset tableData on error
      }).finally(() => {
        this.isLoading = false; // Stop loading after API response
      });
  }




  getDivisionList() {
    this._camService.GetDivisionDetails().then((res: ApiResponse<Division[]>) => {
      if (res.status = 'Success') {
        // Check for multiple rows
        this.divisionList = res.data;
      } else {
        this.divisionList = [];
      }
      // Extract and store BusinessType from the divisionList
      const businessTypes = this.divisionList.map((item) => item.businessType);
    }).catch((err) => {
      const errMsg = 'Something went wrong while fetching division List.';
      this._ToastrApiService.show('error', errMsg)
      console.error('Error fetching division details:', err);
      this._CompanyManagementService.view_error_message(errMsg,err?.code);
    });
  }


  onCountrySelected() {
    this.branchForm.get('branchDetails')?.get('city').setValue('')
  }


  onCitySelected(city: City) {
    this.selectedCity = city;
    this.branchForm.get('city')?.setValue(city.cityCode);
    this.cityControl.setValue(city.cityName);
    this.PreviousCity = city.cityName;
    this.PreviousCityCode = city.cityCode;
  }

  onCityInput(event: Event): void {
    this.isCityDirty = true;
    const input = (event.target as HTMLInputElement).value;

    if (input !== this.PreviousCity) {
      this.cityControl?.setErrors({ InvalidInput: true });
      this.branchForm.setErrors({ cityInvalid: true });
      this.cityControl?.markAsTouched();
      this.cityControl?.markAsDirty();
    } else {
      this.cityControl?.setErrors(null);
      this.cityControl?.markAsUntouched();
    }

    const stateGroupControl = this.branchForm.get('stateGroup');
    if (stateGroupControl && stateGroupControl.value) {
      const countryCode = (
        this.branchForm.get('stateGroup')?.value as { code: string }
      ).code;
      //   if (input.length >= 1 && countryCode) {

      if (countryCode) {
        this.registrationUtility.getCities(countryCode, input).subscribe(
          (cities) => {
            this.filteredCities = cities;
            this.noResultsFound = cities.length === 0;
          },
          (error) => {
            console.error('Error fetching city data', error);
            this.noResultsFound = true;
          }
        );
      } else {
        this.filteredCities = [];
        this.noResultsFound = true;
        this.branchForm.get('city')?.setErrors({ noResults: true });
      }
    } else {
      this.filteredCities = [];
      this.noResultsFound = true;
      this.branchForm.get('city')?.setErrors({ noResults: true });
    }
  }


  displayFn = (option: { name: string; code: string; isdCode: string; countryFlag: string } | null): string => {
    if (!option) return '';

    // Debugging log to check data passed
    let currentC = this.countriesLists.filter(($country: any) => $country.isoCode === option)[0]

    // Set city based on the selected country code
    this.Setcity(currentC.isoCode, "");

    return option ? currentC.countryName : '';
  };

  Setcity(countryCode: string, city: string): void {
    if (countryCode) {
      this.registrationUtility.getCities(countryCode, city).subscribe(
        (cities) => {
          this.filteredCities = cities;
          this.allCities = [...cities]; // Store all cities
          this.noResultsFound = cities.length === 0;
        },
        (error) => {
          console.error('Error fetching city data', error);
          this.noResultsFound = true;
           const message =
          error?.error?.message ||
          error?.message ||
          'Something went wrong. Please try again.';
          this._CompanyManagementService.view_error_message(message,error?.code);
        }
      );
    }
  }



  onCityChange(event: any) {
    const inputValue = event.target.value.trim();

    if (inputValue) {
      this.filteredCities = this.filterCities(inputValue || '');
      this.noResultsFound = this.filteredCities.length === 0;
    } else {
      this.filteredCities = [...this.allCities]; // Reset to all cities if input is empty
      this.noResultsFound = false;
    }
  }


  filterCities(value: string): City[] {
    const filterValue = value.toLowerCase();
    const result = this.filteredCities.filter((city) =>
      city.cityName.toLowerCase().includes(filterValue)
    );
    return result;
  }


  onSubmit() {

    this._CompanyManagementService.office_location_click('Save button','Save', this.tableData.length)//GTM use


    if (!this.branchForm.valid) {
      return;
    }
    const formData: BranchRequest = this.branchForm.value;
    const isUpdate = formData.flag === 'UPDATE';
    this._camService.InsertBranchInformationV1(formData).then((res) => {
      if (res?.status === 'Created') {
        this.getBranchInfoList(); // Refresh branch list
        this.Addnew = false; // Close the form on success

        this._CompanyManagementService.save_success('Office location', 'Success')//GTM use

        const message = isUpdate ? 'Office location information has been updated!' : 'Office location information has been saved successfully!';
        this._ToastrApiService.show('success', message);
        this.branchForm.reset({
          branchDetails: { status: true },
          flag: 'ADD',
          branchId: null,
        });
        this._CommonService.formResetTrigger();
      }

      else if (res?.status === 'Conflict') {
        this._ToastrApiService.show('warning', res?.message);

      } else if (res?.status === 'Success') {
        this.Addnew = false;
        this._ToastrApiService.show('success', res?.message);
        this._CompanyManagementService.save_success('Office location', 'Success')//GTM use
        this._CommonService.formResetTrigger();
      }

      else {
        this._ToastrApiService.show('error', res.message)
        // this._CompanyManagementService.view_error_message(res?.message,res?.message?.code);
      }
    }).catch((err) => {
      console.error('Error inserting branch information:', err);
      const errorMessage =
        err?.error?.message ||
        err?.message ||
        'Something went wrong while saving branch information. Please try again later.';
      this._CompanyManagementService.view_error_message(errorMessage,err?.code);
      this._ToastrApiService.show('error', errorMessage);
    });
  }



  onEdit(item: Branch) {

    this._CompanyManagementService.office_location_click('Edit button','Edit', this.tableData.length)//GTM use

    this.Addnew = true;
    this._camService.getBranchInformationById(item.corpBranchId).then((res: ApiResponse<BranchByIdData[]>) => {
      if (res.status === "Success" && res.data && res.data.length > 0) {
        // Example response structure, adjust based on actual response format
        const branchData: BranchByIdData = res.data[0];
        const countryCode = branchData.countryCode;
        const cityName = branchData.cityName;

        // Helper function to handle empty objects
        const handleEmptyObject = (value: any) => {
          return value && typeof value === 'object' && Object.keys(value).length === 0 ? '' : value;
        }

        // Setting values for nested form groups
        this.branchForm.patchValue({
          flag: 'UPDATE',
          branchId: branchData.corpBranchId,
          branchDetails: {
            countryRegion: branchData.countryCode,
            city: branchData.cityName,
            status: branchData.status,
            // division: branchData.division,
            corporateBranchName: branchData.branchName,
            branchCode: branchData.branchCode,
            alternateBranchCode: branchData.altBranchCode,
            branchEmailAddress: branchData.emailAddress,
            streetAddress: branchData.branchAddress1,
            // countryRegion: branchData.BrabchDetails[0].Country_Code,
            state: '',
            // city: branchData.BrabchDetails[0].City_Name,
            postalCode: handleEmptyObject(branchData.postCode),
            mobileNumber: handleEmptyObject(branchData.phoneNo),
            telephone: handleEmptyObject(branchData.telephoneNo),
            fax: handleEmptyObject(branchData.faxNo),
          },
          // branchPOC: {
          //   contactName: handleEmptyObject(branchData.pocPerson),
          //   contactEmailAddress: handleEmptyObject(branchData.pocEmailAddress),
          //   contactMobile: handleEmptyObject(branchData.pocContactMobileNumber),
          //   gdsOfficeID: handleEmptyObject(branchData.gdsOfficeId),
          //   securityManagerID: handleEmptyObject(branchData.securityManagerId),
          // },
          // references: {
          //   additionalReferenceOne: handleEmptyObject(branchData.additionalRef1),
          //   additionalReferenceTwo: handleEmptyObject(branchData.additionalRef2),
          //   additionalReferenceThree: handleEmptyObject(branchData.additionalRef3),
          //   additionalReferenceFour: handleEmptyObject(branchData.additionalRef4),
          //   additionalReferenceFive: handleEmptyObject(branchData.additionalRef5),
          // },
     
        });

        // Load cities for the selected country
        if (countryCode) {
          this.loadCities(countryCode);
        }
      }
    }).catch((err) => {
      const errMsg = err?.message || err?.error?.message || 'Something went wrong while fetching Branch Information By Id.';
      this._ToastrApiService.show('error', errMsg)
      console.error("Error fetching branch information:", err);
      this._CompanyManagementService.view_error_message(errMsg,err?.code);
    });
  }




  onRemove(item: Branch) {
    this._CompanyManagementService.office_location_click('Remove button','Remove', this.tableData.length)//GTM use

    this.currentItem = item;
    const dialogRef = this.dialog.open(this.selectionWarning, {
      data: item, // Pass the item data
    });

  }

  confirmDelete(item: Branch) {

    const request: CamDeleteModel = {
      id: item.corpBranchId,
      type: 'BRANCH'
    }

    this._camService.DeleteCAMitemBytype(request).then((res) => {
      if (res.status == "Success") {
        this._ToastrApiService.show('success', res.message);
        this.currentItem = undefined;
        this.getBranchInfoList()
        this._CompanyManagementService.office_remove_success('Success')//GTM use
      }
      if (res.status == "Failed") {
        this._ToastrApiService.show('error', 'This Office location is associated with traveller. So his Office location cannot be deleted');
        this.currentItem = undefined;
        this.getBranchInfoList()
      }
    }).catch((error) => {
      const errorMessage =
        error?.error?.message ||
        error?.message ||
        'Something went wrong while deleting the Officelocation. Please try again later.';
        this._CompanyManagementService.view_error_message(errorMessage,error?.code);
      this._ToastrApiService.show('error', errorMessage);
    });
  }

  CloseDialog(result: boolean) {
    if (result) {
      this.confirmDelete(this.currentItem)
      this._CompanyManagementService.office_remove_click('Proceed','Proceed', 'Are you sure you want to remove this Office location?')//GTM use
    }
    if (!result) {
      this._CompanyManagementService.office_remove_click('Cancel','Cancel', 'Are you sure you want to remove this Office location?')//GTM use

    }

    this.dialog.closeAll(); // Closes the dialog
  }



  onCancel() {
    // this.router.navigate(['/cam/company-management']);
    this.Addnew = false
    this.branchForm.reset({
      branchDetails: { status: true },
      flag: 1,
      branchId: 0,
    })
    this._CompanyManagementService.office_location_click('Cancel button','Cancel', this.tableData.length)//GTM use


  }

  checkValidCountrySelection() {

    const enteredValue = this.branchForm.get('branchDetails')?.get('countryRegion')?.value;
    const validSelection = this.countriesLists.some(country => country.isoCode === enteredValue);

    if (!validSelection) {
      this.branchForm.get('branchDetails')?.get('countryRegion')?.setErrors({ invalidCountry: true });

      // Clear city related data
      this.filteredCities = [];
      this.allCities = [];
      this.noResultsFound = true;

    } else {
      this.branchForm.get('branchDetails')?.get('countryRegion')?.setErrors(null);
    }
  }

  onCityBlur() {

    const cityControl = this.branchForm.get('branchDetails')?.get('city');
    const cityInput = cityControl?.value;

    // Check if the input value exists in the filteredCities list
    const isValidCity = this.filteredCities.some(city => city.cityName.toLowerCase() === cityInput.toLowerCase());

    // If the city input is not valid and not an empty string, show the error
    if (cityInput && !isValidCity) {
      cityControl.setErrors({ 'invalidCity': true }); // Set error if city is invalid
      this.noResultsFound = true; // Optionally show "no results" if city doesn't match
    } else {
      // If the city is valid (either selected from the list or entered correctly)
      cityControl.setErrors(null); // Clear any errors
      this.noResultsFound = false; // Reset "no results" state

      // Ensure the input value is updated if it matches only one city from the list
      if (this.filteredCities.length === 1 && isValidCity) {
        cityControl.setValue(this.filteredCities[0].cityName); // Automatically select the first city if valid
      }
    }
  }






  blockInvalidCharacters(event: KeyboardEvent): void {
    // List of invalid characters that can be used for XSS, SQL injection, or path traversal
    const invalidChars = ['<', '>', '"', "'", '`', ';', '--', '\\', '?', '+', '_', '#', '%', '^', '*', '!', '=', '%', '(', ')', '{', '}',];

    // If the pressed key is in the invalidChars array, prevent the input
    if (invalidChars.includes(event.key)) {
      event.preventDefault(); // Block the invalid character
    }
  }

  // Block non-numeric input
  allowedNumberOnly(event: KeyboardEvent) {
    const charCode = event.key.charCodeAt(0);
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }
  disableRightClick(event: MouseEvent): void {
    event.preventDefault();
  }

  onPasteBlocked(event: ClipboardEvent): void {
    event.preventDefault(); // Prevent the paste action
  }

  blockNumbers(event: KeyboardEvent): void {
    // Allow only alphabetic characters and spaces
    if (!/^[a-zA-Z\s]$/.test(event.key)) {
      event.preventDefault(); // Block the invalid character
    }
  }


  blockInvalidCharacters1(event: KeyboardEvent): void {
    // List of invalid characters that can be used for XSS, SQL injection, or path traversal
    const invalidChars = ['<', '>', '"', "'", '`', ';', ',', '/', '.', ':', '$', '|', '[', ']', '~', '--', '@', '\\', '?', '+', '_', '#', '%', '^', '*', '!', '=', '%', '(', ')', '{', '}',];

    // If the pressed key is in the invalidChars array, prevent the input
    if (invalidChars.includes(event.key)) {
      event.preventDefault(); // Block the invalid character
    }
  }

  Onlyrs(event: KeyboardEvent): void {
    const inputElement = event.target as HTMLInputElement;
    const currentInputValue = inputElement.value;


    // Get the character being typed
    const typedChar = event.key;

    // If the character is a dot, check if the previous character was also a dot
    if (typedChar === '.' && currentInputValue.endsWith('.')) {
      this.branchForm.get('email')?.setErrors({ customEmailValidator: true });
      event.preventDefault(); // Prevent input if consecutive dots are found
    }
  }

  blockexceptAttheRate(event: KeyboardEvent): void {
    // List of invalid characters that can be used for XSS, SQL injection, or path traversal
    const invalidChars = [
      '<', '>', '"', "'", '`', ';', ':', '--', '\\', '?', '+', '_', '#', '%', '^', '*', '!', '=', '%', '(', ')', '{', '}'
    ];
    if (invalidChars.includes(event.key)) {
      event.preventDefault(); // Block the invalid character
    }

  }


  blockForAddress(event: KeyboardEvent): void {
    const allowedRegex = /^[a-zA-Z0-9\s&(),.\-\/#]$/;
    if (!allowedRegex.test(event.key)) {
      event.preventDefault();
    }
  }

  blockForTelephone(event: KeyboardEvent): void {
    const allowedRegex = /^[0-9+\-()]$/;
    if (!allowedRegex.test(event.key)) {
      event.preventDefault();
    }
  }

  blockForAlphaNum(event: KeyboardEvent): void {
    const allowedRegex = /^[a-zA-Z0-9\-\_\. ]$/;
    if (!allowedRegex.test(event.key)) {
      event.preventDefault();
    }
  }

  DTbusinessHours(event: KeyboardEvent): void {
    const allowedRegex = /^[a-zA-Z0-9\-\:\(\)]$/;
    if (!allowedRegex.test(event.key)) {
      event.preventDefault();
    }
  }

  sitecoreGetWarningMessage(messageId: string): any {
    return this.content?.warningList?.find(
      (item: any) => item.messageID === messageId
    );
  }

  ngOnDestroy(){
    this.destroy$.next();
    this.destroy$.complete();
  }
}
